export default "__VITE_ASSET__BmmelXGA__"